import { useApolloClient } from "@apollo/client";
import { get, isString, trim } from "lodash";
import { useCallback } from "react";
import { useAuth0 } from "src/contexts/auth0Provider";
import { updateGroupName as updateGroupNameMutation } from "src/queries/mutations/group.graphql";
import { isGroupActive } from "src/util/group";
import eventBus, { EVENTS } from "src/services/eventEmitter";
import { canRename } from "src/util/customerConfig";
import { useWorkspace } from "src/contexts/global/WorkspaceContext";

export const useUpdateTeamName = ({ team }) => {
  const client = useApolloClient();
  const auth = useAuth0();
  const workspace = useWorkspace();

  const canUpdateTeamName =
    canRename(auth?.user, workspace?.config?.groupTypes, team) &&
    isGroupActive(team);

  const updateTeamName = useCallback(
    async (name) => {
      if (get(team, "id") && isString(name)) {
        const response = await client.mutate({
          mutation: updateGroupNameMutation,
          variables: {
            groupId: team.id,
            name: trim(name),
          },
        });

        eventBus.emit(EVENTS.GROUP_RENAMED, response.data.result);

        return true;
      }

      return false;
    },
    [client, team]
  );

  return {
    updateTeamName,
    canUpdateTeamName,
  };
};
